module.exports = __webpack_public_path__ + "476b9218eb3299b3b1ac632c0c49fd80.png";